import React from "react";
import PageTemplate from "./PageTemplate";

const Leaderboard = () => {
  return (
    <PageTemplate
      title="Burn. Rank. Dominate."
      content="In the Trenches, only the strong survive. Froth’s journey started with a launch, but the real fight is on the leaderboards. Burn more = Rank higher. Rank higher = Flex harder. Flex harder = Be a legend."
      image="/assets/compete-leaderboards.png" // ✅ Changed to .png
    />
  );
};

export default Leaderboard;
